var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSearchLinedGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6648 16.6648C16.8844 16.4451 17.2406 16.4451 17.4602 16.6648L22.1477 21.3523C22.3674 21.5719 22.3674 21.9281 22.1477 22.1477C21.9281 22.3674 21.5719 22.3674 21.3523 22.1477L16.6648 17.4602C16.4451 17.2406 16.4451 16.8844 16.6648 16.6648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0357 3.5625C6.90837 3.5625 3.5625 6.90837 3.5625 11.0357C3.5625 15.1631 6.90837 18.5089 11.0357 18.5089C13.1031 18.5089 14.9735 17.6702 16.3271 16.313C17.676 14.9606 18.5089 13.096 18.5089 11.0357C18.5089 6.90837 15.1631 3.5625 11.0357 3.5625ZM2.4375 11.0357C2.4375 6.28705 6.28705 2.4375 11.0357 2.4375C15.7844 2.4375 19.6339 6.28705 19.6339 11.0357C19.6339 13.4058 18.6743 15.5528 17.1236 17.1075C15.5677 18.6676 13.414 19.6339 11.0357 19.6339C6.28705 19.6339 2.4375 15.7844 2.4375 11.0357Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchLinedGuide);
export default __webpack_public_path__ + "static/media/ic_search_lined_guide.6a2312641ac34ddda911fe195fd2d716.svg";
export { ForwardRef as ReactComponent };